import React from "react";

const MobileIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_452_9169)">
        <path
          d="M21.9814 15.9616L17.8033 13.8762C16.7532 13.3512 15.4781 13.6962 14.8405 14.6864L14.1204 15.789C12.9802 15.369 10.1223 13.9813 8.23955 10.0732L9.6648 8.8206C10.4674 8.108 10.6774 6.90784 10.1523 5.9702L7.9095 1.94219C7.59447 1.38711 7.0619 0.982035 6.4468 0.831975C5.82424 0.682013 5.16414 0.786975 4.63158 1.13955L1.78875 2.99982C1.06108 3.47988 0.656058 4.34254 0.768618 5.2051C1.21114 8.7681 3.83646 20.6122 18.756 23.1925C18.8835 23.215 19.011 23.2301 19.1385 23.2301C19.9186 23.2301 20.6463 22.825 21.0813 22.1424L22.8966 19.2545C23.2416 18.6994 23.3391 18.0319 23.1666 17.4017C22.9941 16.7792 22.559 16.2541 21.9814 15.9616Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_452_9169">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MobileIcon;
